import ChatButton from './ChatButton';
import ChatPanel from './ChatPanel';
import { useAIChat } from 'contexts/ai-chat-context';
import { useAuth } from 'contexts/auth-context';

export default function AIChat() {
  const auth = useAuth();
  const { isOpen, setIsOpen } = useAIChat();

  // Hide AI Chat when inside Rider App
  if (auth.getFromRN()) {
    return null;
  }

  return isOpen ? (
    <ChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
  ) : (
    <ChatButton onClick={() => setIsOpen(true)} />
  );
}
